import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=0959047c&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/contactus.less?vue&type=style&index=0&id=0959047c&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0959047c",
  null
  
)

export default component.exports